module.exports = __webpack_public_path__ + "assets/actionCovid1.9d73154d.svg";